import React from 'react';
import { Card, Tag, Checkbox, Form, Empty } from 'antd';
import { TrophyOutlined, CheckCircleFilled } from '@ant-design/icons';

const Section09CertificateConfirmation = ({ academicSnapshot = [], certificateName = '' }) => {
  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-badge">SECTION 09</span>
        <h3>Certificate Information Confirmation</h3>
        <p className="section-description">
          Review your official academic records retrieved directly from the LMS database. Confirm that the given name is authorized to be printed on your certificates.
        </p>
      </div>

      {/* Unified Certificate Name Confirmation */}
      <Card className="cert-global-confirm-card" bordered={false}>
        <div className="cert-global-header">
          <CheckCircleFilled style={{ color: '#059669', fontSize: '1.4rem' }} />
          <div>
            <h4 style={{ margin: 0, color: '#065f46', fontWeight: 700, fontSize: '1.05rem' }}>
              Certificate Name Confirmation
            </h4>
            <p style={{ margin: '2px 0 0', color: '#047857', fontSize: '0.86rem' }}>
              This verified name will appear on all your graduation certificates, diplomas, and official transcripts.
            </p>
          </div>
        </div>

        <div className="cert-global-name-display">
          <span className="cert-label">Given Name to be Printed on Certificates:</span>
          <strong className="cert-name-highlight">
            {certificateName || 'Name from Section 01'}
          </strong>
        </div>

        <Form.Item
          name="certificateNameConfirmed"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) =>
                value ? Promise.resolve() : Promise.reject(new Error('Please confirm that the given name is correct for your certificates')),
            },
          ]}
          style={{ marginBottom: 0 }}
        >
          <Checkbox>
            <span style={{ fontWeight: 600, color: '#065f46', fontSize: '0.94rem' }}>
              I confirm that the given name above is correct and authorized to be printed on all my certificates.
            </span>
          </Checkbox>
        </Form.Item>
      </Card>

      {/* Academic Courses Record List */}
      <div className="academic-records-section">
        <h4 style={{ margin: '0 0 12px', color: '#334155', fontWeight: 600, fontSize: '0.98rem' }}>
          Enrolled Programmes & Academic Snapshot
        </h4>

        {academicSnapshot.length === 0 ? (
          <Card className="empty-academic-card" bordered={false}>
            <Empty
              description={
                <div>
                  <h4>No Enrolled Courses Found Yet</h4>
                  <p>Once you are enrolled in an IBAS diploma or certificate programme, your academic completion details will appear here automatically.</p>
                </div>
              }
            />
          </Card>
        ) : (
          <div className="academic-courses-list">
            {academicSnapshot.map((course, idx) => (
              <Card key={course.courseId || idx} className="academic-course-card" bordered={false}>
                <div className="course-card-top-row">
                  <div className="course-title-group">
                    <div className="course-icon-badge">
                      <TrophyOutlined />
                    </div>
                    <div>
                      <h4 className="course-header-name">{course.courseName}</h4>
                      <span className="course-programme-type">{course.courseType}</span>
                    </div>
                  </div>
                  <Tag color={course.certificateNumber !== 'Pending Verification' ? 'green' : 'blue'}>
                    {course.certificateNumber !== 'Pending Verification' ? 'Certified' : 'Eligible'}
                  </Tag>
                </div>

                {/* Academic Snapshot Grid */}
                <div className="academic-meta-grid">
                  <div className="meta-box">
                    <span className="meta-label">Student Reg. Number</span>
                    <strong className="meta-value">{course.studentRegNo}</strong>
                  </div>

                  <div className="meta-box">
                    <span className="meta-label">Completion / Issue Date</span>
                    <strong className="meta-value">{course.completionDate}</strong>
                  </div>

                  <div className="meta-box">
                    <span className="meta-label">Assessment Marks</span>
                    <strong className="meta-value marks-badge">{course.marks}</strong>
                  </div>

                  <div className="meta-box">
                    <span className="meta-label">Academic Grade</span>
                    <strong className="meta-value grade-badge">{course.grade}</strong>
                  </div>

                  <div className="meta-box">
                    <span className="meta-label">Certificate Serial Number</span>
                    <strong className="meta-value cert-num-badge">{course.certificateNumber}</strong>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Section09CertificateConfirmation;
